import queryString from "query-string";
import { logEvent } from "@src/utils/logClient";
import { LocalStorageWrapper } from "@src/utils/localStorage";
import { normalizeUtmParams } from "@src/utils/utmParams";

const UTM_PARAMS_STORAGE_KEY = "marketing-utm-params";

const storeUtmParams = (parsedLocation: queryString.ParsedQuery<string>): void => {
  const utmParams = normalizeUtmParams(parsedLocation as Record<string, unknown>);

  if (utmParams) {
    LocalStorageWrapper.setItem(UTM_PARAMS_STORAGE_KEY, JSON.stringify(utmParams));
  }
};

const logMarketingPageview = (location: Location): void => {
  const parsedLocation = queryString.parse(location.search);
  delete parsedLocation.checkout_session_id;
  storeUtmParams(parsedLocation);

  if (parsedLocation.utm_campaign) {
    logEvent({
      eventName: `pageview.referrer_link`,
      // @ts-expect-error Type 'string | (string | null)[]' is not assignable to type 'string | number | undefined'.
      eventValue: parsedLocation.utm_campaign,
      metadata: parsedLocation,
    });
  }
};

export { logMarketingPageview, UTM_PARAMS_STORAGE_KEY };
